export const IMAGE_SEARCH_SOURCES = {
  LIBRARY: 'LIBRARY',
  EXTERNAL: 'EXTERNAL',
}

export default {
  auto: '*',
}
